import {
  compose,
  withProps,
  mapProps,
  createSink
} from 'recompose';
import { withStoreDetail } from '../Providers/WithStoreDetail';
import { withTitle } from './WithTitle';
import { withMetaDescription } from './WithMetaDescription';
import { withSelfCanonicalRef } from './WithSelfCanonicalRef';
import { withNoIndexMeta } from './WithNoIndex';
import { withCreateHreflangTags } from './WithHreflang';
import { WithFavicon } from './WithFavicon';
import { withOgTag } from './WithOgTag';
import { WithTwitterTag } from './WithTwitterTag';

const withExtractPropsFromRoute = compose(
  withProps(({ routes }) => {
    let currentRoute = {};
    if (routes.length > 0) {
      currentRoute = routes[routes.length - 1];
    }
    return { currentRoute };
  }),
  mapProps(({
    store: {
      name = 'Photobook'
    } = {},
    currentRoute: {
      noIndex = false,
      label = '',
      helmet: {
        title = '',
        metaDescription = '',
      } = {},
    }
  }) => ({
    noIndex,
    label,
    title,
    metaDescription,
    storeName: name,
  })),
);

export const executeCallbacks = ({ callbacks, ...props }) => {
  callbacks.reduce((unused, callback) => callback(props), null);
};

// eslint-disable-next-line
export const withHelmet = compose(
  withStoreDetail,
  withExtractPropsFromRoute,
  withTitle,
  withMetaDescription,
  withOgTag,
  WithTwitterTag,
  withSelfCanonicalRef,
  withNoIndexMeta,
  withCreateHreflangTags,
  WithFavicon,
);

export default withHelmet(createSink(executeCallbacks));



// WEBPACK FOOTER //
// ./src/Common/Helmet/WithHelmet.js